import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const SrCoin = ({
  size,
  type,
  theme,
  className,
  dataTestId = "sr-coin-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        d="M2.944 1.934C1.631 2.722.668 3.903.668 5.334v5.333c0 1.43.963 2.612 2.276 3.4 1.327.796 3.116 1.267 5.057 1.267 1.941 0 3.73-.471 5.057-1.267 1.314-.788 2.277-1.97 2.277-3.4V5.334c0-1.431-.963-2.612-2.277-3.4C11.732 1.138 9.942.667 8.001.667c-1.94 0-3.73.47-5.057 1.267Zm.686 1.143c-1.1.66-1.629 1.478-1.629 2.257 0 .778.53 1.597 1.63 2.256C4.716 8.242 6.26 8.667 8 8.667c1.741 0 3.285-.425 4.371-1.077 1.1-.66 1.63-1.478 1.63-2.256 0-.779-.53-1.597-1.63-2.257C11.286 2.425 9.742 2 8.002 2 6.26 2 4.716 2.425 3.63 3.077ZM14 8.042a6.067 6.067 0 0 1-.942.692C11.732 9.53 9.942 10 8.001 10c-1.94 0-3.73-.47-5.057-1.266a6.071 6.071 0 0 1-.942-.692c.018.766.548 1.567 1.628 2.215 1.087.652 2.63 1.077 4.371 1.077 1.741 0 3.285-.425 4.371-1.077 1.08-.648 1.61-1.45 1.629-2.215ZM2.003 10.709c.283.255.6.487.942.691 1.327.796 3.116 1.267 5.057 1.267 1.941 0 3.73-.47 5.057-1.267.342-.204.66-.436.943-.691-.019.766-.549 1.567-1.629 2.215-1.086.652-2.63 1.076-4.37 1.076-1.742 0-3.285-.424-4.372-1.076-1.08-.648-1.61-1.45-1.628-2.215Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
